import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { saveChanges } from 'bundles/apex/pipeline/settings/store/actions';

import Modal from 'components/modal';
import Button from 'shared/button';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import ManagedInput from 'components/form/managed_input';
import StageLabel from './stage_label';
import ErrorsAlert from './errors_alert';

export function EditStageModal({
  canCustomizeStages,
  defaultLabel,
  errors,
  saveChanges,
  saving,
  show,
  stage,
  onHide,
}) {
  const [label, setLabel] = useState('');
  const [defaultCloseProbability, setDefaultCloseProbability] = useState(0);
  const [backfillCheck, setBackfillCheck] = useState(false);

  function reset() {
    const stageLabel = stage?.label === defaultLabel ? '' : stage?.label;
    setLabel(stageLabel);
    setDefaultCloseProbability(stage?.defaultCloseProbability);
    setBackfillCheck(false);
  }

  function handleSave() {
    saveChanges({
      ...stage,
      label: label || defaultLabel,
      defaultCloseProbability: defaultCloseProbability,
      backfillCheck,
    });
  }

  return (
    <Modal show={show} onHide={onHide} onShow={reset}>
      <Modal.Header closeButton>Edit Pipeline Stage</Modal.Header>

      <Modal.Body>
        {errors && <ErrorsAlert errors={errors} />}
        <StageLabel stage={stage} />
        <div className="form form-horizontal pt-2">
          {canCustomizeStages && (
            <ManagedFormGroup
              label="Custom Label"
              name="customLabel"
              placeholder={defaultLabel}
              value={label}
              onValueChange={setLabel}
            />
          )}
          <ManagedFormGroup
            label="Default Close Probability"
            name="defaultCloseProbability"
            type="percentage"
            value={defaultCloseProbability === 0 ? '0' : defaultCloseProbability}
            onValueChange={setDefaultCloseProbability}
          />
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div className="d-flex justify-content-between">
          {defaultCloseProbability || defaultCloseProbability === 0 ? (
            <ManagedInput
              name="backfillCheck"
              type="checkbox"
              value={backfillCheck}
              onValueChange={setBackfillCheck}
            >
              Update close probability for all existing {label || defaultLabel} deals
            </ManagedInput>
          ) : <div />}
          <div>
            <Button.Cancel onClick={onHide} />
            <Button.Primary disabled={saving} onClick={handleSave}>Save</Button.Primary>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

EditStageModal.propTypes = {
  canCustomizeStages: PropTypes.bool.isRequired,
  defaultLabel: PropTypes.string.isRequired,
  errors: PropTypes.array,
  saveChanges: PropTypes.func.isRequired,
  saving: PropTypes.bool,
  show: PropTypes.bool.isRequired,
  stage: PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    defaultCloseProbability: PropTypes.number,
  }),
  onHide: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  saving: state.saving,
  errors: state.errors,
  canCustomizeStages: state.canCustomizeStages,
});

const mapDispatchToProps = {
  saveChanges,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditStageModal);
